import { useTranslation } from "react-i18next";
import { ApiError } from "../api/client";
import { de } from "../i18n/locales/de";

type ErrorCode = keyof typeof de.errors;

function isKnownCode(code: string): code is ErrorCode {
  return code in de.errors;
}

// Übersetzt einen Fehler in einen Text für die Oberfläche:
// bekannter API-Code -> übersetzter Text, sonst die Meldung der API
// (deutsch, bewusst nutzertauglich), sonst ein allgemeiner Text.
// Interne Details (Stacktraces) zeigt die API nie, also auch nicht wir.
export function useErrorText(): (error: unknown) => string {
  const { t } = useTranslation();
  return (error) => {
    if (error instanceof ApiError) {
      return isKnownCode(error.code) ? t(`errors.${error.code}`) : error.message;
    }
    return t("app.error");
  };
}

export function ErrorMessage({ error }: { error: unknown }) {
  const errorText = useErrorText();
  const requestId = error instanceof ApiError ? error.requestId : undefined;
  return (
    <div role="alert" className="rounded-md border border-line bg-card p-3 text-sm text-error-fg">
      <p>{errorText(error)}</p>
      {/* Die Request-ID hilft beim Nachschlagen im Log (CloudWatch). */}
      {requestId && <p className="mt-1 text-xs text-ink-muted">ID: {requestId}</p>}
    </div>
  );
}
